import { useQuery, UseQueryResult } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

const useGetGoogleTerms = (
    identifier: string,
): UseQueryResult<ApiResponse<any>, ApiError<null>> => {
    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<any>, ApiError<null>>(
        [`google-terms_${queryKey}`],
        () => dataFetch.get(`${CORE_API_SUFFIX}organization/google-enhanced-conversions/terms`),
    );
};

export default useGetGoogleTerms;
